import React from "react";
import { useState, useEffect } from "react";
import {
    Modal,
    Fade,
    Box,
    Typography,
    Backdrop,
    TextField,
    Button,
    CircularProgress,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
} from "@mui/material";
import { Height } from "@mui/icons-material";
import axios from "axios";
import Cookies from "js-cookie";
import useNotification from "../common/Notification";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    height: "auto",
    transform: "translate(-50%, -50%)",
    width: "50%",
    bgcolor: "background.paper",
    display: "flex",
    // alignItems: "center",
    justifyContent: "center",
    boxShadow: 24,
    borderRadius: 2,
    p: 8,
};

const base_url = "http://api.virtualprachar.com/api/whatsapp/personal/group";

const EditGroup = ({ opening, closing, open }) => {
    const [backdropOpen, setBackdropOpen] = useState(false);
    const [searchedGName, setSeachedGName] = useState("");
    const [options, setOptions] = useState([]);

    const [formData, setFormData] = useState({
        name: "",
        file: null,
    });

    const [errors, setErrors] = useState({
        name: false,
        file: false,
    });
    // Notification

    const showNotification = useNotification();
    const handleClose = () => {
        opening();
    };
    const userId = Cookies.get("userId");
    useEffect(() => {
        // Fetching Options for Groups
        const fetchingOptions = async () => {
            try {
                const res = await axios.get(`${base_url}/get/${userId}`);
                console.log(res.data.data);
                let data = new Set();
                for (let obj of res.data.data) {
                    data.add(obj.group_name);
                }
                let newData = [];
                data.forEach((e) => {
                    newData.push(e);
                });
                // setOptions(res.data.data);
                // setSearchGName("");
                setOptions(newData);
            } catch (e) {
                console.error("Error: ", e);
                showNotification(
                    "Something went wront please refresh the page",
                    "error"
                );
            }
        };

        fetchingOptions();
    }, []);

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        setFormData({ ...formData, file: selectedFile });
        setErrors({ ...errors, file: false });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const userId = Cookies.get("userId");

        const isNameValid = formData.name.trim() !== "";
        const isFileValid = formData.file !== null;

        if (!isNameValid || !isFileValid) {
            setErrors({
                name: !isNameValid,
                file: !isFileValid,
            });
            console.log("kjsdflkjdslkf");
            return;
        }

        console.log("Submitted Data:", formData);

        const newFormData = new FormData();
        newFormData.append("group_name", formData.name);
        newFormData.append("file", formData.file);
        console.log("formdata file : ", formData.file);
        newFormData.append("user_id", userId);

        try {
            setBackdropOpen(true);
            const res = await axios.post(
                `http://api.virtualprachar.com/api/whatsapp/personal/group/update `,
                newFormData
            );

            showNotification("Group Edited Successfully", "success");
            opening(() => false);
            setFormData({
                name: "",
                file: null,
            });
            console.log("response: ", res);
        } catch (e) {
            if (e.status == 409) {
                showNotification(`${e.response?.data?.message}`, "error");
                return;
            }
            if (e.status === 413) {
                showNotification(`${e.response?.data.message}`, "error");
                return;
            }
            if (e.status === 422) {
                showNotification(`${e.response?.data.message}`, "error");
                return;
            }
            showNotification(`${e.message}`, "error");
            console.log("Error: ", e);
        } finally {
            setBackdropOpen(false);
        }

        // You can upload or parse the file here
    };

    const handleSelectionChange = (e) => {
        setSeachedGName(e.target.value);

        setFormData((prev) => ({ ...prev, name: e.target.value }));
    };
    return (
        <div>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={open}
                onClose={handleClose}
                closeAfterTransition
                slots={{ backdrop: Backdrop }}
                slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                }}
            >
                <Fade in={open}>
                    <Box sx={style}>
                        <Box
                            component="form"
                            onSubmit={handleSubmit}
                            sx={{ width: "100%" }}
                        >
                            <Typography
                                variant="h5"
                                component="h2"
                                gutterBottom
                                sx={{ mb: 2 }}
                            >
                                Add Phone Numbers
                            </Typography>
                            <Box
                                sx={{
                                    width: "100%",
                                    // display: "flex",
                                    gap: 1,
                                    mb: 2,
                                }}
                            >
                                <FormControl sx={{ width: "100%" }}>
                                    <InputLabel size="small">
                                        Select a group
                                    </InputLabel>
                                    <Select
                                        value={searchedGName}
                                        fullWidth
                                        label={"Select a group"}
                                        onChange={handleSelectionChange}
                                        size="small"
                                    >
                                        {options.map((option, i) => (
                                            <MenuItem key={i} value={option}>
                                                {option}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                            <Box
                                fullWidth
                                sx={{
                                    width: "100%",
                                    height: "auto",
                                    // p: 2,
                                    // border: "1px solid gray",
                                }}
                            >
                                <Button
                                    variant="contained"
                                    component="label"
                                    sx={{ mb: 1 }}
                                >
                                    Choose Excel File
                                    <input
                                        type="file"
                                        hidden
                                        accept=".xls, .xlsx"
                                        onChange={handleFileChange}
                                    />
                                </Button>
                            </Box>

                            {formData.file && (
                                <Typography variant="body2" sx={{ mb: 2 }}>
                                    Selected file: {formData.file.name}
                                </Typography>
                            )}

                            {errors.file && (
                                <Typography
                                    color="error"
                                    variant="body2"
                                    sx={{ mb: 2 }}
                                >
                                    Please select a Excel file
                                </Typography>
                            )}

                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                fullWidth
                                sx={{ mt: 2 }}
                                disabled={backdropOpen}
                                onClick={handleSubmit}
                            >
                                Submit
                                {backdropOpen ? (
                                    <CircularProgress
                                        size={24}
                                        sx={{
                                            position: "absolute",
                                            top: "50%",
                                            left: "50%",
                                            marginTop: "-12px",
                                            marginLeft: "-12px",
                                        }}
                                    />
                                ) : null}
                            </Button>

                            <Typography
                                sx={{
                                    width: "100%",
                                    height: "auto",
                                    fontSize: "12px",
                                    marginTop: 4,
                                }}
                            >
                                <span style={{ fontWeight: "bold" }}>
                                    Note:{" "}
                                </span>
                                Please upload an Excel sheet containing a column
                                with the heading "phone_number". All phone
                                numbers should be listed below this heading in
                                the same column.
                            </Typography>
                        </Box>
                    </Box>
                </Fade>
            </Modal>
        </div>
    );
};

export default EditGroup;
